import 'nodelist-foreach-polyfill';

export default class {
  constructor(options = {}) {
    this.options = {
      selectors: {
        trigger: '.accordion__button',
        target: '.accordion__panel',
        icon: '.accordion__button-icon',
      },
      classes: {
        iconActive: 'accordion__button-icon--active',
        panelActive: 'accordion__panel--active',
      },
      ...options,
    };

    this.$accordions = document.querySelectorAll(this.options.selectors.trigger);

    if (this.$accordions.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.$accordions.forEach((accordion) => {
      accordion.addEventListener('click', event => this.toggleItem(event));
    });
  }

  toggleItem(event) {
    const button = event.target;
    const icon = button.querySelector(this.options.selectors.icon);
    const panel = button.nextElementSibling;
    if (panel.classList.contains(this.options.classes.panelActive)) {
      this.hide(panel, icon);
    } else {
      this.show(panel, icon);
    }
  }

  show(panel, icon) {
    panel.classList.add(this.options.classes.panelActive);
    icon.classList.add(this.options.classes.iconActive);
  }

  hide(panel, icon) {
    panel.classList.remove(this.options.classes.panelActive);
    icon.classList.remove(this.options.classes.iconActive);
  }
}
